import { useCallback, useEffect, useRef } from "react";

/**
 * Tracks when an Inertia Modal transitions to closed and calls `afterLeave`
 * once the React Aria exit animation completes. Used by the AdminRoutedModal
 * (admin-ui) bridge; the product-ui Modal has its own copy of this gate
 * inside PagePresenter — keep the two in sync.
 */
export function useModalLeaveAnimation(isOpen: boolean, afterLeave: () => void) {
  const leavingRef = useRef(false);

  useEffect(() => {
    if (!isOpen) {
      leavingRef.current = true;
    }
  }, [isOpen]);

  return useCallback(() => {
    if (leavingRef.current) {
      leavingRef.current = false;
      afterLeave();
    }
  }, [afterLeave]);
}
